import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import ImageUploader from "vue-image-upload-resize";
import VueHead from "vue-head";
import VueCountdownTimer from "vuejs-countdown-timer";
import VueSocialSharing from "vue-social-sharing";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
// import TawkMessengerVue from "@tawk.to/tawk-messenger-vue-2";

Vue.prototype.moment = moment;
Vue.use(VueCountdownTimer);
Vue.use(VueApexCharts);
Vue.config.productionTip = false;
Vue.use(ImageUploader);
Vue.use(VueHead);
Vue.use(VueSocialSharing);
Vue.component("apexChart", VueApexCharts);
// Vue.use(TawkMessengerVue, {
//   propertyId: "6375028ab0d6371309cf6031",
//   widgetId: "1gi0h3sd9",
// });
new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
